export default __webpack_public_path__ + "static/media/nature.7606ef10.jpg";